import React, {Component} from 'react';
import {NavLink} from "react-router-dom";
import {Navbar, Nav, NavItem} from 'react-bootstrap';
import LoggedInRoutes from 'routes/loggedInRoute';

class HeaderOptions extends Component {
    constructor(props) {
        super(props);
    }

    logout = () => {
        localStorage.clear();
        const {history} = this.props;
        history.push('/');
    }

    render() {
        return (
            <Navbar.Collapse>
                <Nav pullRight>
                    <NavItem eventKey={1} href="http://lakshyapocketlab.com">
                        Home
                    </NavItem>
                    {LoggedInRoutes.map((prop, key) => {
                        if (prop.redirect) {
                            return null;
                        }
                        return (
                            <NavItem key={key} href={"#" + prop.path}>
                                {prop.name}
                            </NavItem>
                        )
                    })}
                    <NavItem eventKey={2} onClick={this.props.logoutMethod}>
                        Logout
                    </NavItem>
                </Nav>
            </Navbar.Collapse>
        );
    }
}

export default HeaderOptions;



// WEBPACK FOOTER //
// ./src/components/Header/HeaderOptions.jsx